export function ConvertStringToNumberArray(stringData) {
    const result = [];
    stringData.split(',').map((dataNumber) => result.push(Number(dataNumber)))
    return result
}